import { useQuery, QueryResult } from '@apollo/client';
import { gql } from '@apollo/client';

const GET_AUDIT_DOCUMENT_PDF = gql`
  query GetAuditDocumentPdf($documentId: String) {
    getAuditDocumentPdf(documentId: $documentId) {
      fileBase64
      fileName
      mimeType
    }
  }
`;

interface AuditDocumentPdf {
  fileBase64: string;
  fileName: string;
  mimeType: string;
}

interface GetAuditDocumentPdfData {
  getAuditDocumentPdf: AuditDocumentPdf;
}

interface GetAuditDocumentPdfVariables {
  documentId: string;
}

export const useGetAuditDocumentPdf = (documentId: string): QueryResult<GetAuditDocumentPdfData, GetAuditDocumentPdfVariables> => {
  return useQuery<GetAuditDocumentPdfData, GetAuditDocumentPdfVariables>(GET_AUDIT_DOCUMENT_PDF, {
    variables: { documentId },
  });
};

